const sliderThumbs = new Swiper('.slider__thumbs .swiper-container', {
	direction: 'vertical',
	slidesPerView: 6,
	spaceBetween: 20,
	freeMode: true,
	breakpoints: {
		0: {
			direction: 'horizontal',
      spaceBetween: 5,
      slidesPerView: 'auto',
		},
		1007: {
			direction: 'vertical',
		}
	}
});
const sliderImages = new Swiper('.slider__images .swiper-container', {
	direction: 'vertical',
	slidesPerView: 1,
	spaceBetween: 32,
	mousewheel: true,
	navigation: {
		nextEl: '.slider__next',
		prevEl: '.slider__prev'
	},
  pagination: {
    el: ".swiper-pagination",
  },
	grabCursor: true,
	thumbs: {
		swiper: sliderThumbs
	},
	breakpoints: {
		0: {
			direction: 'horizontal',
      mousewheel: false,
      spaceBetween: 0,
      autoHeight: true
		},
		1007: {
			direction: 'vertical',
		}
	}
});
sliderImages.on('slideChange', function (e) {
  if($(".slider__image video").length > 0){
    $(".slider__image video").trigger("pause");
  }
});

$(function(){
  let did = $(".custom-slider-master-li.active").attr("data-id");
  if(did != undefined && did != ""){
    if($(`.custom-swiper--cont .slider__image[data-img="${$(".custom-slider-master-li.active").attr("data-img")}"]`).length > 0){
      let ind = parseInt($(`.custom-swiper--cont .slider__image[data-img="${$(".custom-slider-master-li.active").attr("data-img")}"]`).attr("data-index"));
      $(".custom-swiper--cont")[0].swiper.slideTo(ind);
    }
  }
})